import { render, staticRenderFns } from "./ShopInfoSelector.vue?vue&type=template&id=795dcb0b&scoped=true&"
import script from "./ShopInfoSelector.vue?vue&type=script&lang=js&"
export * from "./ShopInfoSelector.vue?vue&type=script&lang=js&"
import style0 from "./ShopInfoSelector.vue?vue&type=style&index=0&id=795dcb0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795dcb0b",
  null
  
)

export default component.exports